export default function (totalMinutes) {
    const totalHours = moment.duration(totalMinutes, 'minutes').asHours();
    const hours = Math.floor(totalHours);
    const remainingMinutes = moment.duration(parseFloat(((totalHours - hours) % 10).toFixed(2)), 'hours').asMinutes();

    return `${hours} Hrs ${Math.floor(remainingMinutes)} Mins`;
}
